<template>
  <div class="pb-05">
    <v-card rounded="0" elevation="0" class="py-0 row mx-0">
      <v-col cols="4" md="3" class="pr-4 pl-0">
        <v-chip
          class="white--text pr-1"
          :class="formValidation ? 'logistic-color' : 'grey cursor-default'"
          @click="openNewDraftModal()"
        >
          <v-icon color="white">mdi-plus</v-icon>
          <small class="pr-1" style="white-space: nowrap">بار منتخب</small>
        </v-chip>
      </v-col>

      <v-col cols="8" md="9" class="pa-0 my-auto">
        <v-sheet class="mx-auto">
          <v-slide-group show-arrows>
            <v-slide-item
              v-for="(item, index) in drafts"
              :key="'draft-load-' + index"
              v-slot="{ active, toggle }"
            >
              <v-btn
                class="ma-1 px-2 font-xsmall force-size"
                :input-value="active"
                active-class="btn--active"
                depressed
                rounded
                @click="
                  () => {
                    selectDraft(item);
                    toggle();
                  }
                "
              >
                <v-icon x-small>{{
                  active ? "mdi-star" : "mdi-star-outline"
                }}</v-icon>
                {{ item.get("draft_name") }}
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </v-sheet>
      </v-col>
    </v-card>

    <v-dialog v-model="newDraftDialog" max-width="500">
      <v-card class="subtitle1-regular">
        <v-card-title
          class="justify-center high-emp px-4 grey lighten-3"
          style="font-size: inherit"
        >
          ذخیره بار منتخب
        </v-card-title>

        <v-card-text class="pt-6 px-4">
          <v-form v-model="draftValidate" @submit.prevent>
            <v-text-field
              height="50"
              clearable
              outlined
              required
              dense
              class="input-ltr"
              label="نام بار منتخب"
              v-model="newDraftShortName"
              type="text"
              color="var(--logistic)"
              :rules="[$utils.validators.required, $utils.validators.onlyFarsi]"
            ></v-text-field>
          </v-form>
          <div class="font-xsmall grey--text text--darken-2 pr-3">
            مثلا بار گناوه، بار ساوه و ...
          </div>
        </v-card-text>

        <v-card-actions class="center pb-1 pt-0 px-2">
          <v-col cols="6" class="px-2">
            <v-btn
              class="w-100 logistic-color white--text py-5"
              elevation="0"
              :disabled="!draftValidate"
              @click="addNewDraft()"
              :loading="loading"
            >
              تایید
            </v-btn>
          </v-col>
          <v-col cols="6" class="px-2">
            <v-btn
              outlined
              class="
                border border-grey
                d-flex
                justify-center
                align-center
                logistic--text
                force-color
                rounded
                w-100
                py-5
              "
              @click="closeDialog"
            >
              انصراف
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    load: Object,
    type: String,
    insuranceOptions: Array,
    paymentOptions: Array,
    formValidation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      draftValidate: false,
      newDraftDialog: false,
      newDraftShortName: null,
      drafts: [],
      loading: false,
    };
  },

  mounted() {
    this.getDrafts();
  },
  methods: {
    addNewDraft() {
      this.loading = true;
      this.$parseSDK.Cloud.run("submit_company_draft_load_array", {
        draft_name: this.newDraftShortName,
        load_type: this.load.load_type,
        load_value: this.load.load_value,
        tonnage: this.load.tonnage,
        vehicles: this.$utils.standardMultiVehicleList(this.load.vehicle),
        barbar: this.load.barbar,
        description: this.load.description,
        dimensions: this.load.dimensions,
        price: this.load.price * 10,
        package_type: this.load.package_type,
        payed_in_origin: this.load.payed_in_origin,
        with_insurance: this.load.with_insurance,
      })
        .then(() => {
          this.$utils.showMessage("با موفقیت به لیست بارهای منتخب افزوده شد", {
            type: "success",
          });
          this.closeDialog();
          this.getDrafts();
        })
        .catch((err) => {
          if (this.$utils.showMessage("خطا در عملیات")) return;
        })
        .finally(() => (this.loading = false));
    },
    closeDialog() {
      this.newDraftDialog = false;
      this.newDraftShortName = null;
    },
    openNewDraftModal() {
      if (this.formValidation) this.newDraftDialog = true;
      else {
        this.$store.commit("showSnackbar", {
          text: "پس از پر کردن فرم زیر، آدرس منتخب خود را اضافه کنید.",
        });
      }
    },
    async getDrafts() {
      this.drafts = [];
      let request = {
        url: "get_company_draft_loads",
        params: {
          skip_number: 0,
        },
      };

      const response = await this.$parseSDK.Cloud.run(
        request.url,
        request.params
      ).catch((err) => {
        if (this.$utils.handleErrorIfKnown(err.message)) return;
      });

      if (response) {
        response.forEach((item) => {
          this.drafts.unshift(item);
        });
      }
    },
    selectDraft(item) {
      this.$set(this.load, `tonnage`, item.get("tonnage"));
      this.$set(this.load, `dimensions`, item.get("dimensions"));
      this.$set(this.load, `load_value`, item.get("load_value"));
      this.$set(this.load, `description`, item.get("description"));
      this.$set(this.load, `price`, item.get("price") / 10);
      this.$emit("handle-package-dialog", "close", item.get("package_type"));
      this.$emit("handle-bar-dialog", "close", item.get("load_type"));
      this.$emit("handle-vehicle-dialog", "close", {
        barbar: this.$utils.unstandardizedVelicles(item.get("vehicles")),
      });
      this.$emit(
        "switch-insurance",
        this.selectedInsOption(item.get("with_insurance"))
      );
      this.$emit(
        "switch-payment",
        this.selectedPayOption(item.get("payed_in_origin"))
      );
      this.$nextTick(() => this.$emit("handle-update-load-value"));
    },
    selectedInsOption(type) {
      const option = this.insuranceOptions.find((op) => op.value == type);
      return option;
    },
    selectedPayOption(type) {
      const option = this.paymentOptions.find((op) => op.value == type);
      return option;
    },
  },
  computed: {
    person() {
      const person_side = this.type == "sender" ? "فرستنده " : "گیرنده";
      return person_side;
    },
  },
};
</script>
<style >
.border-grey {
  border-color: #e4e4e4;
}
</style>
